<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>
      /<a (click)="navigateToList()" class="text-secondary pointer"> User Roles </a>
      <span *ngIf="admin && utilService.isOpenFromSearch" (click)="navSearchClicked()" class="text-secondary pointer">/ Search</span>
      /<span *ngIf="admin" class="text-secondary"> {{admin.name}}</span></small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console</a>
        /<a (click)="navigateToList()" class="text-secondary  pointer"> User Roles </a>
        <span *ngIf="admin && utilService.isOpenFromSearch" (click)="navSearchClicked()" class="text-secondary pointer">/ Search</span>
      /<span *ngIf="admin" class="text-secondary"> {{admin.name}}</span></small>
    <small *ngIf="accountType == 'VEHICLE_SERVICE_PROVIDER'"><a [routerLink]="['/service-provider/dashboard']"
        class="text-secondary">Admin Console</a>
        /<a (click)="navigateToList()" class="text-secondary  pointer"> User Roles </a>
        <span *ngIf="admin && utilService.isOpenFromSearch" (click)="navSearchClicked()" class="text-secondary pointer">/ Search</span>
      /<span *ngIf="admin" class="text-secondary"> {{admin.name}}</span></small>
    <small *ngIf="accountCategory== 'DEALER'"><a [routerLink]="['/dealer']"
        class="text-secondary">Admin Console</a>
      /<a (click)="navigateToList()" class="text-secondary  pointer"> User Roles </a>
      <span *ngIf="admin && utilService.isOpenFromSearch" (click)="navSearchClicked()" class="text-secondary pointer">/ Search</span>
      /<span *ngIf="admin" class="text-secondary"> {{admin.name}}</span></small>
    <small *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'"><a [routerLink]="['/corporate']"
        class="text-secondary">Admin Console</a>
      /<a (click)="navigateToList()" class="text-secondary  pointer"> User Roles </a>
      <span *ngIf="admin && utilService.isOpenFromSearch" (click)="navSearchClicked()" class="text-secondary pointer">/ Search</span>
      /<span *ngIf="admin" class="text-secondary"> {{admin.name}}</span></small>
  </div>
</div>

<div class="row mt-4 bg-light p-1 no-gutters">
  <div class="col-lg-2 col-md-2 col-sm-3 col-2 text-center my-auto">
    <img *ngIf="admin.image" class="logo-5 rounded-circle" src="{{admin.image}}" alt="{{admin.name}}" />
    <img *ngIf="!admin.image" class="logo-5 rounded-circle" src="assets/images/user_male.png" alt="{{admin.name}}" />
    <br>

  </div>
  <div class="col-lg-7 col-md-7 col-sm-6 col-5 pl-4 my-auto">
    <div class="font14-700">{{admin.name}}&nbsp;&nbsp;
      <span [ngClass]="{'ACTIVE':'badge-success', 'INACTIVE':'badge-danger', 'INVITED':'badge-warning',
      'DISABLED':'badge-danger', 'DELETED':'badge-danger'}[adminStatus]" class="badge badge-pill badge-400">{{adminStatus | customText}}</span>
    </div>
    <div><span class="font13-600">Email: </span><span class="font13-400">{{admin.username}}</span></div>
    <div><span class="font13-600">Phone: </span><span class="font13-400">{{admin.isd}}{{admin.phone}}</span>
      <i *ngIf="isAllowUpdate && adminStatus != 'DELETED'" class="fas fa-edit cursor-pointer ml-3 maroon" data-toggle="tooltip" data-placement="right"
      title="Update User Detail" (click)="openUpdate()"></i></div>
  </div>
  <div class="col-lg-3 col-md-3 col-sm-3 col-5 pl-0 text-right">
    <small><i class="fas fa-times pointer ml-2 text-secondary"  routerLink="/admin-roles" (click)="navSearchClicked()" data-toggle="tooltip"
        data-placement="right" title="Close"></i></small>
    <ng-container *ngIf="admin.id != loggedInUserId">
      <div class="mt-4" *ngIf="adminStatus == 'ACTIVE'">
        <button class="btn btn-light btn-150" (click)="onUserDeactivate()">DEACTIVATE</button>
      </div>
      <div class="mt-4" *ngIf="adminStatus == 'DISABLED'">
        <button class="btn btn-primary btn-150" (click)="onUserActivate()">ACTIVATE</button>
      </div>
      <div class="mt-4" *ngIf="adminStatus == 'INVITED'">
        <button class="btn btn-primary btn-150" (click)="onInviteResend()">RESEND INVITE</button>
      </div>
    </ng-container>
  </div>
</div>

<div class="row mt-4 bg-light p-1 no-gutters">
  <div class="col-12 pb-2 pt-1 font14-700">Account History</div>
  <div class="col-12 mt-2 pb-1">
    <div><span class="font13-600">Created On: </span><span
        class="font13-400">{{admin.createdDate | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</span></div>
    <div *ngIf="admin.lastSignedIn"><span class="font13-600">Last Sign-In: </span><span
        class="font13-400">{{admin.lastSignedIn | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</span></div>
    <div *ngIf="admin.passwordUpdatedAt"><span class="font13-600">Password last changed on: </span><span
        class="font13-400">{{admin.passwordUpdatedAt | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</span></div>
  </div>
</div>

<div class="row mt-4 p-1 bg-light no-gutters">
  <div class="col-12 pb-2 pt-1">
    <div class="row no-gutters">
      <div class="col-lg-9 col-md-8 col-sm-6 col-6 mt-2 pr-0 font14-700">
        Account Security
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 pl-0 text-right" *ngIf="admin.id != loggedInUserId && adminStatus == 'ACTIVE'">
        <button class="btn btn-primary btn-150" (click)="onResetPassword()">RESET PASSWORD</button>
      </div>
    </div>
  </div>
  <div class="col-12 font13-600 mt-2 pb-1">2-Step Verification: 
    <span *ngIf="admin.multiFactorAuthentication" class="font13-400">{{admin.multiFactorAuthentication | customText}} for {{authService.accountData.name}}</span>
    <span *ngIf="!admin.multiFactorAuthentication" class="font13-400">Disabled for {{authService.accountData.name}}</span>
  </div>
</div>


<div class="row mt-4 p-1 bg-light no-gutters" *ngIf="admin && admin.roles && admin.roles.length > 0">
  <div class="col-12 pb-2 pt-1">
    <div class="row no-gutters">
      <div class="col-lg-9 col-md-8 col-sm-6 col-6 mt-2 pr-0 font14-700">
          Roles
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 pl-0 text-right" *ngIf="admin.status != 'DELETED'">
          <button *ngIf="!isSelfAccount" class="btn btn-primary btn-150" (click)="openUpdateRole()">UPDATE ROLE</button>
      </div>
    </div>
    <div class="table-responsive pt-2">
      <table class="table table-bordered table-striped">
         <thead class="thead-light">
              <tr>
                <th scope="col" width="30%">Application</th>
                <th scope="col">Role</th>
              </tr>
            </thead> 
        <tbody>
          <tr *ngFor="let role of admin.roles; let i = index">
            <td>B2B Admin Portal</td>
            <td>{{role | role_display}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<!-- Update Role -->
<button type="button" class="btn btn-primary" id="openUpdateRole" [hidden]="true" data-toggle="modal"
  data-target="#updateRole" data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="updateRole" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="updateRoleTitle">Update Role</h5>
        <button id="closeUpdateRole" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="resetUpdateRoleForm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #updateRoleForm="ngForm" novalidate (ngSubmit)="updateRoleFormSubmit(updateRoleForm)">
        <div class="modal-body">
          <div class="row">
            <div class="col">

              <label>Roles</label><br>
              <div class="custom-control custom-radio">
                <div class="row">
                  <div class="col-6 py-1" *ngFor="let role of userRoles; let i = index">
                    <input type="radio" class="custom-control-input" id="roleAccountAdmin-{{i}}" name="roleAccountAdmin"
                      [checked]="isRolePresent(role)" (change)="roleSelected(role)">
                    <label class="custom-control-label" for="roleAccountAdmin-{{i}}">{{role | role_display}}</label>
                  </div>
                </div>
              </div>
              <!-- <div class="row mt-1">
                <div class="col-6" *ngFor="let role of userRoles">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" class="custom-control-input" id="role-{{role}}" name="role-{{role}}"
                        [checked]="isRolePresent(role)" (change)="roleSelected(role)">
                      <label class="custom-control-label" for="role-{{role}}">{{role | role_display}}</label>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <label class="mt-3">B2B Fleet Application Roles</label>
              <div class="row mt-1">
                <div class="col">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" id="roleFleetOperator" name="roleFleetOperator"
                        [checked]="updateRoleModal.fleetDemoAppRole == 'ROLE_FLEET_OPERATOR'"
                        (change)="fleetDemoAppRoleClicked('ROLE_FLEET_OPERATOR')">
                      <label class="custom-control-label" for="roleFleetOperator">Fleet Operator</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" id="roleRenter" name="roleRenter"
                        [checked]="updateRoleModal.fleetDemoAppRole == 'ROLE_RENTER'" (change)="fleetDemoAppRoleClicked('ROLE_RENTER')">
                      <label class="custom-control-label" for="roleRenter">Renter</label>
                    </div>
                  </div>
                </div>
              </div> -->

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetUpdateRoleForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">UPDATE</button>
        </div>
      </form>
    </div>
  </div>
</div>


<!-- Confirmation Model -->
<div class="modal fade" id="confirmationModel" tabindex="-1" role="dialog" aria-hidden="true">
  <!-- modal-sm -->
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered " role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="userConfirmationTitle" *ngIf="currentConfirmation.heading != null">
          {{currentConfirmation.heading}}</h5>
        <button id="closeConfirmationModel" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center" *ngIf="currentConfirmation.content != null">{{currentConfirmation.content}}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" (click)="confirm()">OK</button>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openConfirmationModel" [hidden]="true" data-toggle="modal"
  data-target="#confirmationModel" data-backdrop="static" data-keyboard="false">Hidden Btn</button>


<!-- Update Profile Modal -->
<button type="button" class="btn btn-primary" id="openUpdateProfile" [hidden]="true" data-toggle="modal"
  data-target="#updateProfile" data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="updateProfile" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="updateProfileTitle">Update Profile</h5>
        <button id="closeUpdateProfile" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="resetUserUpdateForm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #updateUserForm="ngForm" novalidate (ngSubmit)="updateUserFormSubmit(updateUserForm)">
        <div class="modal-body">
          <div class="form-group">
            <label><span class="maroon astrisk">&#10033;&nbsp;</span>Name</label>
            <input type="text" class="form-control" [(ngModel)]="updateUserModal.name" name="name" #name="ngModel"
              required>
            <small class="text-danger text-center" *ngIf="name.errors && updateUserForm.submitted">
              <p class="mb-0" *ngIf="name.errors.required">*Required</p>
            </small>
          </div>
          <!-- <div class="form-group">
            <label><span class="maroon astrisk">&#10033;&nbsp;</span>Country</label>
            <select id="countrySelect" class="w-100" aria-placeholder="Select Country" [(ngModel)]="updateUserModal.country"
              name="country" #country="ngModel" required>
              <option [ngValue]=null>Select Country</option>
              <option *ngFor="let country of countryList" value={{country.name}}>{{country.name}}</option>
            </select>
            <small class="text-danger text-center" *ngIf="country.errors && updateUserForm.submitted">
              <p class="mb-0" *ngIf="country.errors.required">*Required</p>
            </small>
          </div> -->

          <!-- <div class="form-group">
            <label for="adminPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span><span>Phone</span></label>
            <div class="">
              <ngx-intl-tel-input
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [separateDialCode]="true"
                [selectFirstCountry]="false"
                [searchCountryPlaceholder]="'Search Country'"
                [preferredCountries]="preferredCountries"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                [numberFormat]="PhoneNumberFormat.National"
                [selectedCountryISO]="selectedCountryISO"
                (countryChange)="onCountryChange($event)"
                [(ngModel)]="selectedPhone"
                name="countryCode"
                #countryCode="ngModel"
                required>
              </ngx-intl-tel-input>
              <small class="text-danger text-center" *ngIf="countryCode.errors && updateUserForm.submitted">
                <p class="mb-0" *ngIf="countryCode.errors.required">*Required</p>
                <p class="mb-0" *ngIf="!countryCode.errors.required">Invalid Phone</p>
              </small>
            </div>
          </div> -->

        <!-- <div class="form-group">
          <label for="adminPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span><span>Phone</span></label>
          <app-intl-phone-input #IntlPhoneInputComponent (phoneDataEmitter)="getPhoneData($event)" class="intl-phone-input__component"></app-intl-phone-input>
          <ng-container *ngIf="updateUserForm.submitted">
              <ng-container *ngIf="intlPhoneInputComponent.phoneModel.errors && intlPhoneInputComponent.phoneModel.errors.required; else checkValidity">
                  <small class="text-danger text-center">
                      <p class="mb-0">*Required</p>
                  </small>
              </ng-container>
              <ng-template #checkValidity>
                  <small class="text-danger text-center">
                      <p class="mb-0" *ngIf="!intlPhoneInputComponent.isValidNumber()">Invalid Phone</p>
                  </small>
              </ng-template>
          </ng-container>
        </div> -->

        <!-- <div>
          <label for="countryIsd"><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
          <div class="form-group d-flex">
            >!-- Country ISD --<
            <select id="countryIsd" [(ngModel)]="selectedCountryIsd" name="countryIsd" #countryIsd="ngModel"
              class="form-control" style="max-width: 173px; box-shadow: none">
              <option [value]="null">Select ISD</option>
              <option *ngFor="let country of countries" [value]="country.dialCode">{{country.label}}</option>
            </select>
            
            >!-- Phone --<
            <input type="text" class="form-control" id="userPhone" name="userPhone" placeholder="Enter Phone"
              maxlength="12" [(ngModel)]="selectedUserPhone" #userPhone="ngModel" oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
          </div>

          <small class="text-danger text-center" *ngIf="userPhone.errors && updateUserForm.submitted">
            <p class="mb-0" *ngIf="userPhone.errors.required">*Required</p>
          </small>
        </div> -->

        <div>
          <label for="countryIsd"><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
          <div class="form-group d-flex custom-select-wrapper">
            <select [(ngModel)]="adminCountryIsotwo" name="country" (ngModelChange)="countryUpdated($event)">
              <option *ngFor="let c of allCountryList" [value]="c.isotwo">{{c.isd}} {{c.name}}</option>
            </select>
            <span class="selected-isd" *ngIf="adminCountryIsotwo">{{getAdminCountryIsd()}}</span>
            
            <input placeholder="Phone Number" type="text" class="form-control" id="phoneElement" name="phoneElement"
              #phoneElement="ngModel" appPhoneValidator appPhoneFormatter [(ngModel)]="adminPhone" required/>
          </div>
        
          <small class="text-danger text-center" *ngIf="phoneElement?.errors && updateUserForm.submitted">
            <p class="mb-0" *ngIf="phoneElement.errors?.required">*Required</p>
            <p class="mb-0" *ngIf="phoneElement.errors?.invalidPhone">Invalid Phone</p>
          </small>
        </div>

          <!-- <div class="form-group">
            <label><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
            <div class="row">
              <div class="form-group col-4 pr-1">
                <ng-template #rt_isd let-r="result" let-t="term">
                  <ngb-highlight [result]="r.name + ' ' + r.isd" [term]="t"></ngb-highlight>
                </ng-template>
                <input id="typeahead-isd-template" type="text" class="form-control" name="isd" #isd="ngModel" placeholder="ISD..."
                  [(ngModel)]="selectedIsdDetails" [ngbTypeahead]="searchIsd" [resultTemplate]="rt_isd"
                  [inputFormatter]="isdFormatter" [editable]='false' (selectItem)="onIsdSelected($event)" required disabled>
                <small class="text-danger text-center" *ngIf="isd.errors && updateUserForm.submitted">
                  <p class="mb-0" *ngIf="isd.errors.required">*Required</p>
                </small>
              </div> 
              <div class="col-8 pl-1">
                <input type="text" class="form-control" [pattern]="'[0-9]{' + phoneLength + '}'"
                  [placeholder]="'X'.repeat(phoneLength)" [maxlength]="phoneLength" [(ngModel)]="updateUserModal.phone" name="phone"
                  #phone="ngModel" oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
                <small class="text-danger text-center" *ngIf="phone.errors && updateUserForm.submitted">
                  <p class="mb-0" *ngIf="phone.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!phone.errors.required">Invalid Phone</p>
                </small>
              </div>              
            </div>
          </div> -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetUserUpdateForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">UPDATE</button>
        </div>
      </form>
    </div>
  </div>
</div>